import React, { useState } from 'react';
import { Col, Card, Row, CardBody } from 'reactstrap';
import StepOne from './steps/StepOne';
import StepTwo from './steps/StepTwo';
import StepThree from './steps/StepThree';
import { setIsFromModule, uncheckAllItem } from '@/containers/Control-Panel/Assign/redux/actions';
import { useDispatch } from 'react-redux';
import { clearCheckedModule } from '@/containers/Control-Panel/Module/redux/actions';
import { clearCheckedModuleSchedule } from '@/containers/Control-Panel/redux/moduleSchedule/actions';

const AssignModuleWizard = () => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    // initialization
    dispatch(setIsFromModule(true));
    // destruction
    return () => {
      dispatch(setIsFromModule(false));
      dispatch(clearCheckedModule());
      dispatch(clearCheckedModuleSchedule());
      dispatch(uncheckAllItem());
    };
  }, []);

  const [page, setPage] = useState(1);

  const nextPage = () => {
    setPage(page + 1);
  };

  const previousPage = () => {
    setPage(page - 1);
  };

  return (
    <Row>
      <Col md={12} lg={12}>
        <Card className="pb-0">
          <CardBody className="wizard">
            <div className="wizard__steps">
              <div className={`wizard__step${page === 1 ? ' wizard__step--active' : ''}`}>
                <p>Modules</p>
              </div>
              <div className={`wizard__step${page === 2 ? ' wizard__step--active' : ''}`}>
                <p>Schedules</p>
              </div>
              <div className={`wizard__step${page === 3 ? ' wizard__step--active' : ''}`}>
                <p>Assign Users OR Organizations</p>
              </div>
            </div>
            <div className="">
              {page === 1 && <StepOne onSubmit={nextPage} />}
              {page === 2 && <StepTwo previousPage={previousPage} nextPage={nextPage} />}
              {page === 3 && <StepThree previousPage={previousPage} />}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AssignModuleWizard;
